<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title>
        <span class="md-text">Delete confirmation</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="warning" class="mb-0 mt-4 mb-4" prominent>
          Are you sure you want to permanently delete the selected {{ ProductsToDelete.length }} product{{ ProductsToDelete.length !== 1 ? 's' : '' }}?
        </v-alert>

        <div v-if="submit_loading" class="mt-4">
          <v-progress-linear
            v-model="deletingProgressPercentage"
            color="error"
            style="pointer-events: none"
            striped
            height="8"
          ></v-progress-linear>
          <div class="text-center mt-2 text-caption">
            Deleting {{ deletingProgress }}/{{ ProductsToDelete.length }}
          </div>
        </div>
        
        <p v-if="!submit_loading" class="text-caption text--secondary mb-0 mt-3">
          This action cannot be undone. All selected product matches will be permanently removed.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          class="text-none"
          small
          @click="deleteProducts"
          :loading="submit_loading"
          :disabled="submit_loading"
        >
          Yes, delete {{ ProductsToDelete.length > 1 ? 'them' : 'it' }}!
        </v-btn>
        <v-btn 
          color="error" 
          small
          class="text-none"
          @click="dialog = false"
          :disabled="submit_loading"
        >
          cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'deleteMatchModalMultipl',
    props: ['ProductsToDelete', 'show', 'component_name'],
    data() {
      return {
        dialog: false,
        deleting: false,
        deletingProgress: 0,
        deletingProgressPercentage: 0,
        submit_loading: false,
        deletingErrors: [],
      }
    },
    methods: {
      async wait(time = 500) {
        return await new Promise((resolve) => setTimeout(resolve, time))
      },
      async getPercentageFromProgress() {
        this.deletingProgressPercentage =
          (this.deletingProgress / this.ProductsToDelete.length) * 100
      },
      async deleteProducts() {
        this.submit_loading = true
        for (let i = 0; i < this.ProductsToDelete.length; i++) {
          /**
           * waiting to reduce the rate of the requests to the server
           */
          await this.wait(100)
          await axios
            .get(`/api/products/delete`, {
              params: {
                account: localStorage.getItem('account_id'),
                user: localStorage.getItem('user_id'),
                component: this.component_name,
                ref: this.ProductsToDelete[i].match_ref,
                match: this.ProductsToDelete[i].match_id,
              },
            })
            .catch((err) => {
              this.deletingErrors.push({
                ref: this.ProductsToDelete[i].match_ref,
                match: this.ProductsToDelete[i].match_id,
                error: err.response.data.error,
              })
            })
          this.deletingProgress = i + 1
          this.getPercentageFromProgress()
        }
        /**
         * we are waiting to make sure that the data is sync between mongodb and elasticsearch
         * so we can avoid some data displaying issues in the dashboard
         */
        await this.wait(1000)
        this.submit_loading = false
        this.dialog = false
        this.deletingProgress = 0
        this.$emit('callback-function')
      },
    },
    watch: {
      show: {
        handler() {
          this.dialog = this.dialog ? false : true
        },
      },
    },
  }
</script>
<style scoped>
  .product-image-delete {
    height: 100px;
  }
  .brand-text {
    font-size: 1rem;
    font-weight: 600;
  }
  .product-name-text {
    font-size: 1.2rem;
  }
  .delete-msg {
    font-size: 1.4em;
  }
</style>
